import MenuNames from "../../../constants/Menu/MenuNames.json";
import OnboardingDetails from "../../../views/OnboardingDetails";

const qualityCheckRoutes = [
  {
    menuName: MenuNames.DRIVER_ONBOARDING,
    path: "/onboarding-details",
    component: OnboardingDetails,
    exact: true,
  },
];

export default qualityCheckRoutes;
